import axios from "@/api/axiosInstance";
import { OpportunitiesResponse } from "../types";

export const fetchMyOpportunities = async (
  signal?: AbortSignal,
): Promise<OpportunitiesResponse> => {
  const response = await axios.get<OpportunitiesResponse>(
    "/api/private/sales-portal/opportunities/my",
    { signal },
  );
  return response.data;
};
